<template>
  <createContent/>
</template>

<script>
import createContent from '@/components/_managerolecompany/_update/updatePerson.vue'
export default {
  components: {
    createContent
  }
}
</script>
